// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__3mw60","img":"UserMenu_img__2Qyck","text":"UserMenu_text__30ekA","button":"UserMenu_button__2FO8T"};